import { Grid } from '@chakra-ui/react'
import type { TaskSlaDashboardData } from '@/lib/services/taskSlaService'
import DashboardSection from './DashboardSection'
import DashboardStatCard from './DashboardStatCard'

type Props = {
  data: TaskSlaDashboardData
  loading?: boolean
}

export default function TaskSlaSection({ data, loading }: Props) {
  return (
    <DashboardSection title="Task SLA" actionLabel="Task reports ↗" actionTo="/reports/task-reports">
      <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={2.5}>
        <DashboardStatCard
          label="Tasks breached"
          value={data.sla.breached}
          loading={loading}
          labelColor="red.600"
          valueColor="red.700"
          accent="red.400"
        />
        <DashboardStatCard
          label="Within SLA"
          value={data.sla.within_sla}
          loading={loading}
          labelColor="green.700"
          valueColor="green.800"
          accent="green.400"
        />
        <DashboardStatCard
          label="Response met rate"
          value={`${data.sla.response_met_rate.toFixed(1)}%`}
          loading={loading}
          labelColor="blue.700"
          accent="blue.300"
        />
      </Grid>
    </DashboardSection>
  )
}
